import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'en' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc2ODQ2MDUwMjcwOCwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTAyNzUxIn0.Oo9o2zU61WJumub5H26BNeJ1NxNFVYsiDjkNce8GxoDo6ySe24Vp0BOfkGPisPXsh7w2x8VjcsFo_c1ZInyRkw`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
